// extracted by mini-css-extract-plugin
export default {"NewProjectMemberDialog":"NewProjectMemberDialog_NewProjectMemberDialog__AfuPG"};